import { localisationConfigs } from '../constants/localisationConfigs';
// @ts-ignore
import i18n from '~/frontend/i18n';

export function LocalisationTimeFormats() {
  const currentLocale = i18n.language;
  switch (currentLocale) {
    case 'en-US':
      return localisationConfigs.us.timeFormats;
    default:
      return localisationConfigs.default.timeFormats;
  }
}
